<template>
  <span>
    <v-btn class="btn" outlined color="primary" rounded @click="handleClick">{{
      $t('hubspot.myData')
    }}</v-btn>
    <v-dialog ref="editDialog" v-model="editDialog" max-width="1200" scrollable persistent>
      <UsermanagementEdit
        v-if="editDialog"
        :addresses="addresses"
        :templates="[]"
        :errors="saveUserError"
        :pending="requestPending"
        :self-edit="true"
        :user="currentUser"
        @save="handleSave"
        @close="handleClose"
        @update-user="updateSelf"
      />
    </v-dialog>
  </span>
</template>

<script>
import { cloneDeep, merge } from 'lodash-es'
import { objectDiff } from '@/js/helper/object-diff-helper.js'
import MyDataMixin from '@/js/components/Usermanagement/my-data-mixin.js'
import UsermanagementEdit from '@/js/components/Usermanagement/UsermanagementEdit.vue'

export default {
  name: 'MyDataButton',
  components: {
    UsermanagementEdit,
  },
  mixins: [MyDataMixin],
  props: {
    compareData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      editDialog: false,
      dataWasSaved: false,
      compareCustomer: {},
    }
  },
  computed: {
    changes() {
      return this.getChangedData()
    },
  },
  methods: {
    async handleClick() {
      await this.getCustomer(true)
      this.setInitialDealerInfos()
      this.compareCustomer = merge(cloneDeep(this.currentUser), cloneDeep(this.compareData))
      this.editDialog = true
      this.$emit('click')
    },
    async handleSave(userData) {
      this.dataWasSaved = await this.saveSelf(userData)
      if (this.dataWasSaved) {
        this.$emit('input', { user: this.currentUser, changes: this.getChangedData() })
      }
    },
    handleClose() {
      this.editDialog = false
    },
    getChangedData() {
      return objectDiff(cloneDeep(this.compareCustomer), cloneDeep(this.currentUser))
    },
  },
}
</script>

<style lang="scss" module></style>
